import React from 'react';

import './index.scss'

const ButtonSubmit = ({title}) => {
    return (
        <div className="form-btn-wrapper" style={{textAlign: 'center', position: 'initial', left: 'auto', transform: 'none'}}>
            <button className="main__balloons-btn bold">{title}</button>
        </div>
    )
}

export default ButtonSubmit;